<template>
  <div class="goods-order">
    <div class="order-main">
      <div class="logo"><img src="../assets/logo.png" alt=""></div>
      <div class="address">
        <div class="title">收货人信息</div>
        <div class="address-list">
          <div class="item-address" :class="{active : address.IsDefault}" v-for="(address, addressId) in addressList" :key="addressId" @click="handleActive(addressId)">
            <p class="name"><span>{{address.Receiver}} 收</span><span v-if="address.IsDefault">默认地址</span></p>
            <p style="margin-bottom:20px;height:40px;overflow:hidden;"><span>{{address.ProvinceName+address.CityName+address.CountyName+address.TownName+address.Address}}</span>
              <span>&nbsp;{{address.Phone}}</span>
            </p>
            <p><el-button type="text" size="mini" @click="editAddress(address)">修改</el-button></p>
          </div>
        </div>
        <div class="btnbox">
          <el-button type="text" @click="newAddress">新增收货地址<i class="el-icon-plus el-icon--right"></i></el-button>
          <el-button type="text" v-if="isMore" @click="moreAddress">更多地址<i :class="moreIcon" class="el-icon--right"></i></el-button>
          <!-- <div class="btn" @click="newAddress">+新增收货地址</div> -->
        </div>
      </div>
      <div class="goods">
        <div class="title">确认商品信息</div>
        <div class="main-goods">
          <div class="goods-tab">
            <span class="tab1">商品信息</span>
            <span class="tab2">商品型号</span>
            <span class="tab3">单价(元)</span>
            <span class="tab4">数量</span>
            <span class="tab5">金额(元)</span>
          </div>
          <div class="shop-name">这里是店铺名称</div>
          <div class="goods-info" v-for="(item, index) in settleList" :key="index">
            <div class="info-box">
              <div class="goods-tab name">
                <div class="tab1 img">
                  <img style="width:40px;height:40px;margin-right:14px;" :src="item.SkuPicUrl" alt="">
                  <span class="txt">{{item.SkuName}}</span>
                </div>
                <span class="tab2"></span>
                <span class="tab3 txt">￥{{item.SkuPrice}}</span>
                <span class="tab4 txt">{{item.SkuNumber}}</span>
                <span class="tab5 txt">￥{{item.Subtotal}}</span>
              </div>
            </div>
            <div class="activity">
              <div class="gift">
                <span>赠品：</span>
                <div class="gift-list" v-if="item.IsHasGift">
                  <span class="item-gift">海尔冰箱一台海尔冰箱一台海尔海尔冰箱一台海尔海尔冰箱一台海尔冰…</span>
                  <span class="item-gift">海尔冰箱一台海尔冰箱一台海尔海尔冰箱一台海尔海尔冰箱一台海尔冰…</span>
                </div>
                <span style="color:#f40000;" v-else>暂无赠品</span>
              </div>
              <div class="gift">
                <span>红包：</span>
                <div class="gift-list" v-if="item.IsHasGift">
                  <span class="item-red">海尔冰箱一台海尔冰箱一台海尔海尔冰箱一台海尔海尔冰箱一台海尔冰…</span>
                  <span class="item-red">海尔冰箱一台海尔冰箱一台海尔海尔冰箱一台海尔海尔冰箱一台海尔冰…</span>
                </div>
                <span style="color:#f40000;" v-else>暂无红包</span>
              </div>
            </div>
          </div>
          <div class="remarks">
            <el-form :inline="true" label-width="100px">
              <el-form-item label="优惠券：">
                <!-- <el-select></el-select> -->
              </el-form-item>
              <el-form-item label="红包：">
                <!-- <el-select></el-select> -->
              </el-form-item>
              <el-form-item label="留言：">
                <el-input type="textarea"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="price">
            <div class="price-top">
              <p><span>{{selectedSkuNumber}}件商品，总金额：</span><span class="money">¥{{selectedSkuAmount}}</span></p>
              <p><span>已优惠：</span><span class="money">0.00</span></p>
              <p><span>运费：</span><span class="money">0.00</span></p>
            </div>
            <div class="price-bottom">
              <p><span>应付总额：</span><span class="money redTxt">¥{{selectedSkuAmount}}</span></p>
              <p><span>配送至：</span><span>{{defaultAddress.ProvinceName+defaultAddress.CityName+defaultAddress.CountyName+defaultAddress.TownName+defaultAddress.Address}}</span>
              <span style="margin-left:15px;">收货人：</span><span>{{defaultAddress.Receiver}} {{defaultAddress.Phone}}</span></p>
            </div>
            <div class="btn-box">
              <div class="btn1" @click="backShoppingCart">返回购物车修改</div>
              <div class="btn2" @click="submitOrder">提交订单</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 添加地址 -->
    <!-- <el-dialog
      title="新增收货地址"
      :visible.sync="dialogVisible"
      width="750px"
      :before-close="handleClose">
    </el-dialog> -->
      <ax-address v-if="dialogVisible" :dataAddress="dataAddress" @closeFun="handleClose" @updateFun="updateAddressList"></ax-address>
  </div>
</template>
<script>
import address from '../components/AXaddAddress.vue'
import {
  ShoppingCartSettleList,
  AddressList, // 收获地址列表
  CreateOrder,
  DirectSettleList
} from '../api/api'
export default {
  name: 'goodsOrder',
  components: {
    'ax-address': address
  },
  data(){
    return{
      moreIcon: 'el-icon-arrow-down',
      isShowMoreAddress: false,
      isMore: false,
      dialogVisible: false,
      activeIndex: 1,
      settleList: [],
      addressList: [],
      selectedSkuAmount: 0,
      selectedSkuNumber: 0,
      dataAddress: {},
      defaultAddress: {}, // 默认收货地址
    }
  },
  created(){
    this.getSettleList()
    this.getAddressList()
  },
  methods:{
    backShoppingCart(){
      this.$router.push('/shoppingCart')
    },
    handleClose(data){
      this.dialogVisible = data
    },
    newAddress(){
      this.dialogVisible = true
    },
    updateAddressList(){
      this.getAddressList()
      this.getSettleList()
    },
    moreAddress(){
      this.isShowMoreAddress = !this.isShowMoreAddress
      if(this.isShowMoreAddress){
        this.addressList = this.moreAddressList
        this.moreIcon = 'el-icon-arrow-up'
      } else{
        this.moreIcon = 'el-icon-arrow-down'
        this.addressList = this.moreAddressList.slice(0,4)
      }
    },
    editAddress(val){
      this.dataAddress = val
      this.dialogVisible = true
    },
    getAddressList(){
      let params = {
        pageIndex: 1,
        padding: 20
      }
      AddressList(params).then(res => {
        if(res.data.success){
          this.moreIcon = 'el-icon-arrow-down'
          let list = res.data.response.data || []
          list.map((item,index) => {
            if(item.IsDefault){
              list.unshift(list.splice(index,1)[0])
            }
          })
          if(list.length >=4){
            this.addressList = list.slice(0,4)
            this.moreAddressList = res.data.response.data || []
            this.isMore = true
            this.isShowMoreAddress = false
          } else {
            this.addressList = list
            this.isMore = false
            this.isShowMoreAddress = true
          }
        } else{
          this.$message.error(res.data.msg)
        }
      })
    },
    getSettleList(){
      if(this.$route.query.skuId){
        let params = {
          skuId: this.$route.query.skuId,
          skuNumber: this.$route.query.skuNumber
        }
        DirectSettleList(params).then(res => {
          if(res.data.success){
            this.settleList = res.data.response.SettleList || []
            this.settleList.forEach(item => {
              item.Subtotal = item.SkuPrice * item.SkuNumber
              this.selectedSkuNumber += item.SkuNumber
            })
            this.selectedSkuAmount = res.data.response.SelectedSkuAmount
            this.defaultAddress = res.data.response.DefaultAddress
            // this.selectedSkuNumber = res.data.response.SelectedSkuNumber
          } else {
            this.$message.error(res.data.msg)
          }
        })
      } else{
        ShoppingCartSettleList().then(res => {
          if(res.data.success){
            this.settleList = res.data.response.SettleList || []
            this.settleList.forEach(item => {
              item.Subtotal = item.SkuPrice * item.SkuNumber
              this.selectedSkuNumber += item.SkuNumber
            })
            this.selectedSkuAmount = res.data.response.SelectedSkuAmount
            this.defaultAddress = res.data.response.DefaultAddress
            // this.selectedSkuNumber = res.data.response.SelectedSkuNumber
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }
    },
    submitOrder(){
      let list = []
      this.settleList.forEach(item => {
        list.push({
          shoppingCartId: item.ShoppingCartId,
          skuId: item.SkuId,
          skuNumber: item.SkuNumber
        })
      })
      let params = {
        addressId: this.defaultAddress.Id,
        // remark: ,
        skuList: list
      }
      CreateOrder(params).then(res => {
        if(res.data.success){
          this.$router.push({path: '/payment', query: {
            orderNo: res.data.response.OrderNo,
            money: res.data.response.OrderAmount
          }})
        } else{
          this.$message.error(res.data.msg)
        }
      })
    },
    handleActive(val){
      this.activeIndex = val
    }
  }
}
</script>
<style lang="scss" scoped>
.goods-order{
  background: #ffffff;
  padding-top: 25px;
  text-align: left;
  .order-main{
    width: 1200px;
    margin: 0 auto;
    .logo{
      margin-bottom: 39px;
    }
    .title{
      font-size: 18px;
      font-weight: bold;
      color: #333333;
      line-height: 30px;
      border-bottom: 1px solid #edf1f2;
    }
    .address-list{
      padding-top: 19px;
      padding-bottom: 22px;
      font-size: 14px;
      color: #333333;
      line-height: 22px;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      .item-address{
        display: inline-block;
        width: 250px;
        height: 130px;
        border: 1px solid #e1e1e1;
        padding: 10px 20px;
        margin-right: 10px;
        margin-bottom: 10px;
        .name{
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 15px;
        }
      }
      .item-address:nth-child(4n){
        margin-right: 0;
      }
      .active{
        width: 250px;
        height: 130px;
        padding: 9px 19px;
        border: 2px solid #f40000;
        background: url('../assets/bg_hook.png') no-repeat right bottom;
      }
    }
    .btn{
      width: 124px;
      height: 28px;
      color: #333333;
      font-size: 15px;
      line-height: 30px;
      border: 1px solid #cccccc;
      text-align: center;
      margin-bottom: 27px;
      cursor: pointer;
    }
    .main-goods{
      padding-top: 12px; 
      font-size: 14px;
      font-weight: 500;
      color: #999999;
      line-height: 20px;
      .goods-tab{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 24px;
        .tab1{
          width: 420px;
        }
        .tab2{
          width: 230px;
        }
        .tab3{
          width: 215px;
        }
        .tab4{
          width: 100px;
        }
      }
      .shop-name{
        margin-top: 10px;
        height: 40px;
        line-height: 40px;
        background: #f3f3f3;
        color: #333333;
        font-size: 16px;
        font-weight: bold;
        padding-left: 24px;
      }
      .goods-info{
        border: 1px solid #cccccc;
        padding-bottom: 34px;
        margin-bottom: 20px;
        .name{
          padding: 21px 24px;
        }
        .img{
          display: flex;
          justify-content: flex-start;
          align-items: center;
        }
        .activity{
          padding: 0 78px;
          .gift{
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            .item-gift{
              display: block;
              line-height: 18px;
              margin-bottom: 10px;
            }
            .item-gift:before{
              content: url(../assets/zengpin.png);
              margin-right: 10px;
              display: inline;
              vertical-align: middle;
            }
            .item-red{
              display: block;
              line-height: 18px;
              margin-bottom: 10px;
            }
            .item-red::before{
              content: url(../assets/hongbao.png);
              margin-right: 10px;
              display: inline;
              vertical-align: middle;
            }
          }
        }
      }
      .remarks{
        margin-top: 20px;
        border: 1px solid #cccccc;
        padding: 16px 40px 24px 24px;
      }
      .price{
        text-align: right;
        color: #666666;
        padding: 16px 0;
        span{
          display: inline-block;
        }
        .money{
          width: 150px;
        }
        .price-top{
          line-height: 20px;
          padding-right: 18px;
          >p{
            margin-bottom: 14px;
          }
        }
        .price-bottom{
          background: #f3f3f3;
          line-height: 20px;
          padding: 20px 18px 6px 0;
          >p{
            margin-bottom: 14px;
          }
        }
        .redTxt{
          font-size: 24px;
          font-weight: bold;
          color: #f40000;
          // line-height: 33px;
        }
      }
      .btn-box{
        padding: 22px 18px 66px 0;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .btn1{      
          font-size: 16px;
          font-weight: 400;
          color: #0097F8;
          line-height: 22px;
          cursor: pointer;
          margin-right: 24px;
        }
        .btn2{
          width: 164px;
          height: 44px;
          font-size: 20px;
          font-weight: 800;
          background: #f40000;
          color: #ffffff;
          line-height: 44px;
          text-align: center;
          border-radius: 4px;
          cursor: pointer;
        }
      }
      .el-textarea{
        width: 675px;
      }
      .txt{
        font-size: 14px;
        color: #333333;
        font-weight: bold;
      }
    }
  }
}
</style>